var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play_circle_icon_svg__clip0_298_2724)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play_circle_icon_svg__clip1_298_2724)",
    stroke: "#3A3A3A",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.53 16.8a7.801 7.801 0 100-15.601 7.801 7.801 0 000 15.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97 5.88L13.652 9l-4.68 3.12V5.88z",
    fill: "#3A3A3A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "play_circle_icon_svg__clip0_298_2724"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 9.765 9.765)",
    d: "M0 0h18.722v18.722H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "play_circle_icon_svg__clip1_298_2724"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.17 -.361)",
    d: "M0 0h18.722v18.722H0z"
  })))));
}
export default SvgPlayCircleIcon;